import { RESET_ALL_STATES } from "../actions/actions";

import {
  VALIDATE_OTP_REQUEST,
  VALIDATE_OTP_SUCCESS,
  VALIDATE_OTP_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  isLoading: false,
  error: null,
  data: null,
};

const otpReducer = (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_OTP_REQUEST:
      return { ...state, isLoading: true, error: null };
    case VALIDATE_OTP_SUCCESS:
      return { ...state, isLoading: false, data: action.payload };
    case VALIDATE_OTP_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case RESET_ALL_STATES:
      return initialState;
    default:
      return state;
  }
};

export default otpReducer;
